import axiosServices from "../utils/axios";

import type { PilotTrackerMovement } from "../utils/types/pilotTracker";

export const fetchPilotTrackerMovements = async (): Promise<PilotTrackerMovement[]> => {
  const response = await axiosServices.get(`/pilot-tracker`);
  return response.data.data;
};
